import React, { Component, PropTypes } from 'react'
import { connect } from 'react-redux'
import * as actions from 'actions'
import assets from 'modules/assets'

import ArchivePhotoGrid from 'components/Archive/ArchivePhotoGrid'
import ArchiveUserBio from 'components/Archive/ArchiveUserBio'

class Sempai2017 extends Component {
  constructor(props) {
    super(props)
    this.state = {
      isFetching: true,
      year: props.year,
      country: 'troupeA',
      isScrollIntoView: props.isScrollIntoView
    }
  }
  componentDidMount() {
    let url = assets('camp/2017/sempai.md')
    this.props.dispatch(actions.token.fetchSempai2017Data(url))
    if (this.state.isScrollIntoView) {
      this.props.dispatch(actions.token.toggleMinimizeAlert(true))
      setTimeout(() => {
        this.refs.sempai.scrollIntoView()
      }, 1)
    }
  }
  componentWillReceiveProps(nextProps) {
    this.setState({
      archiveData: nextProps.sempai2017Data,
      isFetching: nextProps.isFetching
    })
  }
  changeCountry = (country) => {
    this.setState({
      country: country
    })
  }
  changeVisible = (option) => {
    this.setState({
      visible: option
    })
  }
  render() {
    let left, right
    left = <ArchivePhotoGrid photoPath = {'images/sempai2017/'} country={this.state.country} archiveData={this.state && this.state.archiveData} year={this.state.year} isFetching={this.state.isFetching}/>
    right = <ArchiveUserBio  country={this.state.country} archiveData={this.state && this.state.archiveData} year={this.state.year} isFetching={this.state.isFetching}/>

    let country = this.state.country
    let visible = this.state.visible
    let active = 'active', inactive = 'inactive'

    let sectionTitle = <h3 style={{marginBottom: '25px'}}>Sempai</h3>

    return (
      <div className="archive-main sempai-2017-main" ref="sempai" id="sempai">
        <div className="main-grid">
          <ul className="grid group">
            {sectionTitle}

            <div className="archive-header">
              <li className="grid-large group archive-menu">
                <div className="archive-menu-left">
                  <h5 className={country === 'troupeA' ? active : inactive} onClick={this.changeCountry.bind(this, 'troupeA')}>Troupe A (France / Japan)</h5>
                  <h5 className={country === 'troupeB' ? active : inactive} onClick={this.changeCountry.bind(this, 'troupeB')}>Troupe B (Romania / Indonesia)</h5>
                </div>
              </li>
            </div>

            <li className="grid-large archive-grid">
              {left}
            </li>
            <li className="grid-small inner-left archive-grid">
              {right}
            </li>

          </ul>

        </div>
      </div>
    )
  }
}
Sempai2017.contextTypes = {
}
Sempai2017.propTypes = {
}
function mapStateToProps(state, ownProps) {
  return {
    sempai2017Data: state.token.sempai2017Data,
    fetchingSempai2017Data: state.token.fetchingSempai2017Data,
    routes: ownProps
  }
}

export default connect(mapStateToProps)(Sempai2017)



// WEBPACK FOOTER //
// ./src/components/camps/2017/Sempai2017.js